import { Controller } from "@hotwired/stimulus";

// Live 3x-income check on the employment step. Sums each adult's annual income
// (dollars) into a household monthly figure and compares it to the required
// amount (3x the true monthly cost), toggling a pass/short indicator.
//
//   <div data-controller="income-requirement"
//        data-income-requirement-required-cents-value="660000">
//     <input data-income-requirement-target="annual" data-action="input->income-requirement#recalculate">
//     <input data-income-requirement-target="additional" ...>
//     <span data-income-requirement-target="monthly"></span>
//     <span data-income-requirement-target="status"></span>
//   </div>
export default class extends Controller {
  static targets = ["annual", "additional", "monthly", "status"];
  static values = { requiredCents: Number };

  connect() {
    this.recalculate();
  }

  recalculate() {
    let monthlyCents = 0;

    this.annualTargets.forEach((el) => {
      monthlyCents += Math.round((this.parseMoney(el.value) * 100) / 12);
    });
    this.additionalTargets.forEach((el) => {
      monthlyCents += Math.round(this.parseMoney(el.value) * 100);
    });

    // Before anything is entered, stay neutral — opening the step with a red
    // "Below the requirement" verdict against $0 reads as a rebuke.
    const untouched = [...this.annualTargets, ...this.additionalTargets].every(
      (el) => el.value.trim() === "",
    );

    if (this.hasMonthlyTarget) {
      this.monthlyTarget.textContent = untouched
        ? "—"
        : this.formatCents(monthlyCents);
    }

    if (!this.hasStatusTarget || !this.requiredCentsValue) return;

    if (untouched) {
      this.statusTarget.textContent = `Enter income below to compare against the ${this.formatCents(this.requiredCentsValue)}/mo requirement`;
      this.statusTarget.classList.remove("text-success", "text-danger");
      this.statusTarget.classList.add("text-muted");
      return;
    }

    const meets = monthlyCents >= this.requiredCentsValue;
    this.statusTarget.textContent = meets
      ? `Meets the ${this.formatCents(this.requiredCentsValue)}/mo requirement`
      : `Below the ${this.formatCents(this.requiredCentsValue)}/mo requirement`;
    this.statusTarget.classList.remove("text-muted");
    this.statusTarget.classList.toggle("text-success", meets);
    this.statusTarget.classList.toggle("text-danger", !meets);
  }

  // Mirror Monetizable: strip currency formatting first. parseFloat("90,000")
  // is 90, which rendered a wrong "Below the requirement" against a salary that
  // comfortably met it.
  parseMoney(raw) {
    return parseFloat(String(raw).replace(/[$,\s]/g, "")) || 0;
  }

  formatCents(cents) {
    return (cents / 100).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    });
  }
}
